import colors from './colors';

export default {
  normal: {
    fontSize: 18,
    padding: 16,
    color: colors.text,
  },
  normalLarge: {
    fontSize: 20,
    padding: 16,
    color: 'dimgrey',
  },
  normalSmall: {
    fontSize: 16,
    padding: 16,
    color: 'grey',
  },
  subtitle: {
    fontSize: 20,
    padding: 20,
    fontWeight: 'bold',
    color: colors.primary,
  },
  highlight: {
    fontSize: 16,
    padding: 2,
    color: colors.accent,
  },
  highlightSmall: {
    fontSize: 16,
    padding: 2,
    color: colors.accent,
  },
};



// WEBPACK FOOTER //
// ./src/styles/text.js